import { Component, inject, model, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { form, maxLength, required, FormField } from '@angular/forms/signals';
import { IProductoCarritoData } from '@core/interfaces/entidades/productoCarrito.entidad';
import { CrearGestionTiempoReq } from '@core/interfaces/request-response/gestion-tiempo.dto.interface';
import { GestionTiempoApiService } from '@core/services/api/gestion-tiempo-api.service';
import { AgregarProducto2 } from '@shared/components/agregar-producto-2/agregar-producto-2';
import { ToastService } from '@shared/services/toast.service';
import { FormErrorMessagePipe } from '../../../shared/pipes/form-error-message.pipe';
import { logger } from '@shared/utils/functions.utils';

@Component({
  selector: 'app-agregar-gestion-tiempo',
  imports: [AgregarProducto2, FormField, FormErrorMessagePipe],
  templateUrl: './agregar-gestion-tiempo.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './agregar-gestion-tiempo.css',
})
export class AgregrarGestionTiempo {
  // servicios
  private gestionTiempoApiService = inject(GestionTiempoApiService);
  private toastService = inject(ToastService);
  // datos
  productos_carrito = model<IProductoCarritoData[]>([]);
  formulario = form(
    signal({
      titulo: '',
      descripcion: '',
    }),
    (x) => {
      required(x.titulo, { message: 'El título es obligatorio.' });
      maxLength(x.titulo, 100, { message: 'El título no puede exceder los 100 caracteres.' });
      maxLength(x.descripcion, 120, {
        message: 'La descripción no puede exceder los 120 caracteres.',
      });
    },
  );
  cerrar = output<void>();
  // metodos
  private checkInvalidForm() {
    if (this.formulario().invalid()) {
      this.formulario.titulo().markAsTouched();
      this.formulario.descripcion().markAsTouched();
      return true;
    }
    return false;
  }
  private resetearFormulario() {
    this.formulario().reset();
    this.productos_carrito.set([]);
  }
  crear() {
    logger(this.productos_carrito());
    if (this.checkInvalidForm()) return;
    if (this.productos_carrito().length === 0) {
      this.toastService.show(
        'top-right',
        'warn',
        'Atención',
        'Debes agregar al menos un producto o servicio para crear una gestión de tiempo.',
      );
      return;
    }

    const { titulo, descripcion } = this.formulario().controlValue();
    const rq: CrearGestionTiempoReq = {
      titulo,
      descripcion: descripcion || undefined,
      items: this.productos_carrito().map((producto) => ({
        producto_id: producto.id,
        nombre_producto: producto.nombre,
        codigo_producto: producto.codigo || null,
        precio_unitario: producto.precio,
        cantidad: producto.cantidad,
        subtotal: producto.precio * producto.cantidad,
        duracion_minutos: producto.producto_servicio?.duracion_minutos || null,
        nota: producto.nota ?? null,
      })),
    };
    this.gestionTiempoApiService.crear(rq).subscribe({
      next: (rs) => {
        this.resetearFormulario();
        this.toastService.show(
          'top-right',
          'success',
          'Éxito',
          'La gestión de tiempo se ha creado correctamente.',
        );
        this.cerrar.emit();
      },
      error: (err) => {
        if (err.status == 401) return;
        this.toastService.show(
          'top-right',
          'error',
          'Error',
          err?.error?.message ||
            'No se pudo crear la gestión de tiempo. Por favor, intenta nuevamente.',
        );
      },
    });
  }
}
